import React from 'react';
import './FlagIcon.css'
import {FLAG_PREFIX} from "../../../constants/tokens";
import FlagLayers from "./FlagLayers";

const FlagIcon = ({token}) => {
  const playerColor = token.replace(FLAG_PREFIX, '');

  return (
    <div className={`central-quarter-icon-container`}>
      <FlagLayers color={playerColor}/>
    </div>
  );
};

export default FlagIcon;
